import styled from 'styled-components'
import { StepProcessWrapper } from './StepProcessWrapper.styles.js'
import PropTypes from 'prop-types'
import { themeColor, themeFontSize, themeFontWeight } from '../../util/themeLenses.js'
import { Box, Flex, styles } from '../../../index.js'

const mediaScreenMobile = props => `@media screen and (min-width: ${props.theme.screens.medium})`

export const STATUS_FINISH = 'finish'
export const STATUS_PROCESS = 'process'
export const STATUS_WAIT = 'wait'
export const STATUS_TYPES = [STATUS_FINISH, STATUS_PROCESS, STATUS_WAIT]

const getColor = ({status, theme}) => {
    if (status == STATUS_FINISH || status == STATUS_PROCESS){
        return themeColor(theme.components.stepper.main)
    } else {
        return  themeColor('gray40')
    }
}

const getNumberColor = ({status}) => {
    if (status == STATUS_FINISH || status == STATUS_PROCESS){
        return themeColor('white')
    } else {
        return  themeColor('gray90')
    }
}

export const StepExtraInfoContainer = styled(Box)`
    display: none;
    ${mediaScreenMobile} {
        display: flex;
        cursor: pointer;
    }
`

export const StepsSeparator = styled.div`
    height: 3px;
    background-color: ${getColor};
    width: 100%;
    margin-top: 13px;
    margin-bottom: 16px;
    min-width: 3px;
`

StepsSeparator.propTypes = {
    status: PropTypes.oneOf(STATUS_TYPES)
}

export const StepsBar = styled.nav`
    position: sticky;
    top: 0;
    z-index:2;
    background-color: white;
    ${mediaScreenMobile} {
        position: initial;
        box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
    }
`

export const StepsBarWrapper = styled(StepProcessWrapper)`
    display: flex;
    margin-bottom: 0;
    flex-flow: row wrap;
    width: calc(100% - 24px);
    justify-content: space-between;
    align-items:  stretch;
`

export const StepNumber = styled.span`
    display: inline-flex;
    color: ${getNumberColor};
    font-weight: ${themeFontWeight('medium')};
    min-width: 25px;
    height: 25px;
    align-items: center;
    justify-content: center;
    font-size: ${themeFontSize('small')};
    background-color: ${getColor};
    line-height: 1px;
    border: 2px solid ${getColor};
    border-radius: 16px;
    ${mediaScreenMobile} {
        margin-left: 0px;
        margin-right: 8px;
    }
`

StepNumber.propTypes = {
    status: PropTypes.oneOf(STATUS_TYPES)
}

export const StepItem = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    height: auto;
    flex: 1 1 auto;

    justify-content: center;
    align-items: center;

    color: ${getColor};
    background-color: transparent;
    padding: 0px;

    ${mediaScreenMobile} {
        ${styles.width}
        align-items: flex-start;
        flex: ${({ hideSeparator }) => hideSeparator ? '0 0 auto' : '1 1 auto'};
        overflow: hidden;
    }

    &:last-of-type {
        &:after { display: none }
        &:before { display: none }
    }
`

StepItem.propTypes = {
    width: PropTypes.string,
    status: PropTypes.oneOf(STATUS_TYPES),
}

StepItem.defaultProps = {
    width: 'auto',
}

export const StepName = styled.div.attrs(props => ({'data-test': props.dataTest}))`
    font-weight: 500;
    cursor: ${({ status }) => status === STATUS_FINISH ? 'pointer' : 'default'};
    width: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-direction: column;
    position: relative;

    ${mediaScreenMobile} {
        flex-direction: row;
        padding: 0px;
        min-height: 32px;
        color: ${getColor};
    }
`

export const StepProgressContainer = styled(Flex)`
    flex-direction: column;
    ${mediaScreenMobile} {
        flex-direction: row;
    }
`

StepName.propTypes = {
    status: PropTypes.oneOf(STATUS_TYPES),
}
